import { List, Map } from 'immutable';
import { RESET_STATE } from "../actions/General";
import { DATA_ERROR_FRESH_SEARCH_RESULTS, DATA_ERROR_MORE_SEARCH_RESULTS, RECEIVE_FRESH_SEARCH_RESULTS, RECEIVE_MORE_SEARCH_RESULTS, RETRIEVE_FRESH_SEARCH_RESULTS, RETRIEVE_MORE_SEARCH_RESULTS } from "../actions/Search";
const initialState = Map({
  currentPage: undefined,
  dataError: false,
  dataErrorMessages: List(),
  initialized: false,
  loadingFreshSearchResults: false,
  loadingMoreResults: false,
  moreResultsDataError: false,
  moreResultsDataErrorMessages: List(),
  searchInProgress: false,
  currentSearchId: undefined,
  searchResults: Map({
    hits: undefined,
    numberOfHits: undefined,
    numberOfPages: undefined
  })
});
function appendSearchResults(_ref) {
  let {
    oldSearchResults,
    newSearchResults
  } = _ref;
  return Map({
    hits: oldSearchResults.get('hits').concat(newSearchResults.get('hits')),
    numberOfHits: newSearchResults.get('numberOfHits'),
    numberOfPages: newSearchResults.get('numberOfPages')
  });
}
export default function SearchReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case RESET_STATE:
      return initialState;
    case RETRIEVE_FRESH_SEARCH_RESULTS:
      return state.set('pendingSearchId', action.searchId).set('searchInProgress', true).set('loadingFreshSearchResults', true);
    case RECEIVE_FRESH_SEARCH_RESULTS:
      return state.get('pendingSearchId') === action.searchId ? state.set('pendingSearchId', undefined).set('currentSearchId', action.searchId).set('initialized', true).set('searchInProgress', false).set('searchResults', action.searchResults).set('loadingFreshSearchResults', false).set('dataError', false).set('dataErrorMessages', List()).set('currentPage', 0) : state;
    case DATA_ERROR_FRESH_SEARCH_RESULTS:
      return state.update('searchResults', searchResults => searchResults.set('hits', undefined).set('numberOfHits', 0).set('numberOfPages', 0)).set('searchInProgress', false).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
    case RETRIEVE_MORE_SEARCH_RESULTS:
      return state.set('searchInProgress', true).set('loadingMoreResults', true);
    case RECEIVE_MORE_SEARCH_RESULTS:
      return state.set('searchInProgress', false).set('loadingMoreResults', false).set('searchResults', appendSearchResults({
        oldSearchResults: state.get('searchResults'),
        newSearchResults: action.searchResults
      })).set('moreResultsDataError', false).set('moreResultsDataErrorMessages', List()).set('currentPage', action.page);
    case DATA_ERROR_MORE_SEARCH_RESULTS:
      return state.set('searchInProgress', false).set('loadingMoreResults', false).set('moreResultsDataError', true).set('moreResultsDataErrorMessages', action.dataErrorMessages);
    default:
      return state;
  }
}